<template>
  <div class="menunav">
    <div class="nav-img">
      <img src="../assets/logo-nav.png" style="height: 60px;" />
    </div>
    <div class="nav">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        background-color="#fff"
        text-color="#000"
        active-text-color="#3070b3"
        :router="true"
      >
      <el-menu-item index="home"><a>首页</a></el-menu-item>
        <el-submenu index="product">
          <template slot="title">产品中心</template>
          <!-- <el-menu-item index="product?pid=1"><a>USW无人机水质采样系统</a></el-menu-item> -->
          <!-- <el-menu-item index="product?pid=2"><a>M300无人机水体采样系统</a></el-menu-item> -->
          <el-menu-item v-for="(val,i) in categoryL" :key="i" :index="'product?pID='+val['pID']">
            <a>{{val["title"]}}</a>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="demo"><a>应用案例</a></el-menu-item>
        <el-submenu index="support">
          <template slot="title">服务与支持</template>
          <el-menu-item index="downloads"><a>资料下载</a></el-menu-item>
          <el-menu-item index="news"><a>新闻动态</a></el-menu-item>
          <el-menu-item index="videos"><a>视频中心</a></el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="news"><a>新闻资讯</a></el-menu-item> -->
        <el-menu-item index="about"><a>关于我们</a></el-menu-item>
      </el-menu>
    </div>

  </div>
</template>

<script>
export default {
  data() { 
    return {
      categoryL:[]
    };
  },
  created() {
    this.$http.get("api/vue_config/product_category").then((response) => {
      // console.log(response.data.data)
      this.categoryL = JSON.parse(response.data.data)
    });

  },

};
</script>

<style lang="less" scoped>
@text-color:#000;
@title-size: 18px;
@title-height: 60px;


.menunav {
  background: #fff;
  width: 100%;
  margin: 0 auto;
  min-width: 100%;
}
.nav {
  height: @title-height;
  // line-height: @title-height;

  margin: 0 auto;
  text-align: center;
  a {
    color: #000;
    text-decoration: none;
    padding: 0 40px;
    font-size: @title-size;
    display: inline-block;
    // font-weight: bold;
  }
  
}
/deep/.el-menu{ 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  height: @title-height;
}
/deep/.el-submenu__title { 
  font-size: @title-size;
  // font-weight: bold;
  i{color: @text-color;} 
}
.el-menu.el-menu--horizontal { border-bottom: none; }

// .el-menu-item{
//   font-weight: bold;
// }

.nav-img{
  position: absolute;
  left: 100px;
  top: 0px;
  z-index: 1;
}
</style>
